type LoadedActionModal<T> = {
    actionRef: string;
    data: T;
};

type ActionModalError = {
    actionRef: string;
    message: string;
};

export const getMatchingActionModalData = <T>(
    loadedModal: LoadedActionModal<T> | undefined,
    actionRef: string | undefined,
) => {
    if (!loadedModal || loadedModal.actionRef !== actionRef) return undefined;
    return loadedModal.data;
};

export const getMatchingActionModalError = (
    queryError: ActionModalError | undefined,
    actionRef: string | undefined,
) => {
    if (!queryError || queryError.actionRef !== actionRef) return '';
    return queryError.message;
};
